import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { TypeParams } from '../../types'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Plugin for the {@link ec.Name.Predefined.RelayProcess} collection that
 * provides polling mechanism for process updates
 */
// TODO: Remove, once subscriptions for process updates are implemented.
export class Plugin extends ec.plugins.Plugin<
  TypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static id = ec.plugins.Plugin.Id.Custom.create(
    'RelayProcessPollingPlugin',
  )

  /**
   * Local storage instance that persists plugin state across browser sessions.
   *
   * Provides a slice of the {@link Plugin} state that is preserved in the
   * browser's
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage localStorage}.
   *
   * @see {@link store.storage.included.LocalStorage}
   */
  public localStorage

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this, this.localStorage),
    })
    this.localStorage = new store.storage.included.LocalStorage<{
      isStarted: store.storage.PropertyConfig<boolean>
    }>({
      name: 'LocalStorage',
      parent: this.feature,
      properties: {
        isStarted: store.storage.property({
          get: stored => !!stored,
          set: value => value,
        }),
      },
    })

    this.feature.registerEffects(
      effects.requestOnTimer(this, this.localStorage),
      effects.updateLocalStorageOnToggle(this.localStorage),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export interface Params {
      collection: ec.Collection<TypeParams>
    }
  }
}
